import {
  CloudDownloadOutlined,
  ColumnHeightOutlined,
  FontSizeOutlined,
  GoogleOutlined,
} from '@ant-design/icons'
import { Flex } from 'antd'
import { ReactNode } from 'react'
import { FormInputType } from '../../../../common/types'

const Label = (props: { icon: string | ReactNode; content: string }) => {
  return (
    <Flex gap={8} align="center">
      {typeof props.icon === 'string' ? (
        <i className={props.icon}></i>
      ) : (
        props.icon
      )}{' '}
      {props.content}
    </Flex>
  )
}

export const useInputTypeOptions = () => {
  const store: Record<FormInputType['inputType'], { label: ReactNode }> = {
    Input: {
      label: <Label icon="las la-quote-left" content="Input" />,
    },
    Textarea: {
      label: <Label icon="las la-align-left" content="Textarea" />,
    },
    Select: {
      label: <Label icon="las la-stream" content="Select" />,
    },
    InputNumber: {
      label: <Label icon="las la-hashtag" content="Number" />,
    },
    Switch: {
      label: <Label icon="las la-toggle-on" content="Switch" />,
    },
    Upload: {
      label: <Label icon="las la-file-upload" content="Upload" />,
    },
    Dynamic: {
      label: <Label icon="las la-stream" content="Dynamic" />,
    },
    SelectProviderAccount: {
      label: <Label icon="las la-user-circle" content="Provider Account" />,
    },
    ProviderAccountAuthorization: {
      label: (
        <Label icon="las la-user-circle" content="Provider Authorization" />
      ),
    },
    SelectProviderAction: {
      label: <Label icon="las la-cogs" content="Provider Action" />,
    },
    GooglePicker: {
      label: <Label icon={<GoogleOutlined />} content="Google Picker" />,
    },
    OneDrivePicker: {
      label: (
        <Label icon={<CloudDownloadOutlined />} content="OneDrive Picker" />
      ),
    },
    DatePicker: {
      label: <Label icon="las la-calendar-alt" content="DatePicker" />,
    },
    RRulePicker: {
      label: <Label icon="las la-calendar-alt" content="RRule Picker" />,
    },
    Checkbox: {
      label: <Label icon="las la-check-square" content="Checkbox" />,
    },
    Radio: {
      label: <Label icon="las la-dot-circle" content="Radio" />,
    },
    RadioCard: {
      label: <Label icon="las la-dot-circle" content="Radio Card" />,
    },
    Rate: {
      label: <Label icon="las la-star" content="Rate" />,
    },
    Slider: {
      label: <Label icon="las la-sliders-h" content="Slider" />,
    },
    TimePicker: {
      label: <Label icon="las la-clock" content="TimePicker" />,
    },
    Transfer: {
      label: <Label icon="las la-exchange-alt" content="Transfer" />,
    },
    TreeSelect: {
      label: <Label icon="las la-sitemap" content="TreeSelect" />,
    },
    ColorPicker: {
      label: <Label icon="las la-dot-circle" content="Color Picker" />,
    },
    Cascader: {
      label: <Label icon="las la-project-diagram" content="Cascader" />,
    },
    Text: {
      label: <Label icon={<FontSizeOutlined />} content="Text" />,
    },
    Title: {
      label: <Label icon={<FontSizeOutlined />} content="Title" />,
    },
    Paragraph: {
      label: <Label icon={<FontSizeOutlined />} content="Paragraph" />,
    },
    Divider: {
      label: <Label icon={<ColumnHeightOutlined />} content="Divider" />,
    },
    TagWall: {
      label: <Label icon="las la-tags" content="Tag Wall" />,
    },
  }

  return Object.entries(store).map(([key, option]) => ({
    ...option,
    value: key,
  }))
}
